
import styled from 'styled-components';

import { ImageUrl } from '../../../utils/constants';
const Header = styled.div`
  width: 100%;
  max-width: 1248px;
  height:160px;
  background-color: ${({ bgColor }) => bgColor || '#1C4667'};
  display: flex;
  margin: auto;
  border-radius: 3px;
  margin-top: ${({ marginTop }) => (marginTop ? '0px' : '25px')};
  margin-bottom: ${({ marginBottom }) => (marginBottom ? '25px' : '')};
  background-image: ${({ backgroundImage }) =>
    backgroundImage ? `url(${ImageUrl}${backgroundImage})` : 'none'};
  background-size: cover;
    background-position: center;
    background-repeat: no-repeat;

  ${'' /* > div:first-child {
    width: 79px;
    display: block;
    border-radius: 3px;
  } */}

  ${'' /* > div:nth-child(2) {
    width: calc(100% - 115px);
    display: flex;
  } */}
`;




const ThemContainer = styled.div`
display: flex;

.first{
  font-family: lato;
  font-size: 24px;
  line-height: 36px;
  color: ${({ bgColor }) => bgColor || '#8D4964'};
  margin-top: 28px;
  margin-bottom: 8px;
}
.last{
  font-family: lato;
  font-size: 40px;
  line-height: 68px;
  color: ${({ bgColor }) => bgColor || '#8D4964'};
  font-weight:700;
}
.theme-text{
    margin-left:36px;

}

> div:nth-child(2) {
  display: flex;
  justify-content: flex-end;
  width: 25%;
  >div{
    width: 115px;
    height: 100%;
    width: auto;
    margin-right:85px;
    max-height:162px;
    >img{
      width: 100%;
      height: 100%;
    }
  }
  >svg{
    margin: auto 85px 0 auto; 
  }
}
`;

const CoachHeading = styled.div`
color: var(--Font-Color-on-Light-theme-500, #184A61);
text-align: center;
font-family: Lato;
font-size: 18px;
font-style: normal;
font-weight: 400;
line-height: 24px; 

`;

const CategoryCardV1 = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding:${({ cardPadding }) => (cardPadding ? cardPadding : '10px 15px')};
  height:${({ cardHeight }) => (cardHeight ? cardHeight : '80px')};
  background: white;
  border-radius:${({ isCardRadius }) => (isCardRadius ? isCardRadius : '12px')};
  margin-bottom: 4px;
  width: calc((100% - 35px) / 3);
  overflow: hidden;
  ${'' /* transition: box-shadow 0.3s ease; */}
  gap: 12px;
  cursor:pointer;
.icon{
    background:${({ background }) => (background ? background : '#f2f2f2')};
    border: 1px solid #E8E8E8;
    padding:8px;
    border-radius:${({ isBorderRadius }) => (isBorderRadius ? isBorderRadius : '50%')};
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;

img{
    border-radius:${({ isBorderRadius }) => (isBorderRadius ? isBorderRadius : '50%')};
    width: 32px;
    height: 32px;
    object-fit: contain;
}
}

.name{
    min-width: 0;
    color: #184A61;
    font-family: Lato;
    font-size: 18px;
    font-weight: 400;
    line-height: 24px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}
`





const CategoryCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding:${({ cardPadding }) => (cardPadding ? cardPadding : '10px 15px')};
  height:${({ cardHeight }) => (cardHeight ? cardHeight : '80px')};
  background: white;
  border-radius:${({ isCardRadius }) => (isCardRadius ? isCardRadius : '12px')};
  margin-bottom: 4px;
  width: calc((100% - 35px) / 3);
  overflow: hidden;
  ${'' /* transition: box-shadow 0.3s ease; */}
  gap: 12px; 
  cursor:pointer;
.icon{
    background:${({ background }) => (background ? background : '#f2f2f2')};
    border:${({ background }) => (background ? background : '1px solid')};
    padding:8px;
    border-radius:50% !important;
    border-radius:${({ isBorderRadius }) => (isBorderRadius ? isBorderRadius : '50%')};
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;

img{
    border-radius:50%;
width: 24px;
height: 24px;

}
}

.name{
    min-width: 0;
    color: #184A61;
    font-family: Lato;
    font-size: 18px;
    font-weight: 400;
    line-height: 24px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}
`

export { Header, ThemContainer,CategoryCard, CategoryCardV1, CoachHeading};
